import {PageRequest} from '../core/pagination/page-request';
import {MaandJaar} from '../core/date/maand-jaar';
import {ExtendedPrestatieCijfer} from './prestatie-cijfer';
import {Page} from '../core/pagination/page';

export class PrestatieCijfersPageRequest extends PageRequest<ExtendedPrestatieCijfer> {

  static nextPageRequestFromPage(currentPage: Page<ExtendedPrestatieCijfer>, maandJaar: MaandJaar): PrestatieCijfersPageRequest {
    return new PrestatieCijfersPageRequest(
      currentPage.isAscending(),
      currentPage.getPageSize(),
      currentPage.getNextPageNumber(),
      currentPage.getPageNumber(),
      currentPage.getFirstItemOnPage(),
      currentPage.getLastItemOnPage(),
      maandJaar.jaar,
      maandJaar.maand,
    );
  }

  static firstPrestatieCijfersRequest(maandJaar: MaandJaar): PrestatieCijfersPageRequest {
    return new PrestatieCijfersPageRequest(
      true,
      100,
      1,
      0,
      undefined,
      undefined,
      maandJaar.jaar,
      maandJaar.maand,
    );
  }

  constructor(
    ascending: boolean,
    pageSize: number,
    pageNumber: number,
    previousPageNumber: number,
    firstItemPreviousPage?: ExtendedPrestatieCijfer,
    lastItemPreviousPage?: ExtendedPrestatieCijfer,
    public jaar?: number,
    public maand?: number,
  ) {
    super(ascending, pageSize, pageNumber, previousPageNumber, firstItemPreviousPage, lastItemPreviousPage);
  }

  getMaandJaar(): MaandJaar {
    return new MaandJaar(this.maand, this.jaar);
  }
}
